import { render, staticRenderFns } from "./MarqueeRoll.vue?vue&type=template&id=020291d6&scoped=true"
import script from "./MarqueeRoll.vue?vue&type=script&lang=js"
export * from "./MarqueeRoll.vue?vue&type=script&lang=js"
import style0 from "./MarqueeRoll.vue?vue&type=style&index=0&id=020291d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020291d6",
  null
  
)

export default component.exports